import { Injectable, signal, computed, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

export type Language = 'it' | 'en';

@Injectable({
    providedIn: 'root'
})
export class I18nService {
    private currentLang = signal<Language>('it');
    public readonly lang = this.currentLang.asReadonly();

    private translations: Record<Language, Record<string, string>> = {
        it: {
            'dashboard.title': 'Management Dashboard',
            'dashboard.welcome': 'Bentornato!',
            'dashboard.welcomeDetail': 'Benvenuto nella tua area di gestione.',
            'dashboard.userInfo': 'Informazioni Utente',
            'dashboard.authStatus': 'Stato Autenticazione',
            'dashboard.features': 'Funzionalità',
            'dashboard.logout': 'Logout',
            'login.title': 'Accesso',
            'login.subtitle': 'Bentornato! Effettua il login',
            'login.email': 'Email',
            'login.username': 'Username',
            'login.password': 'Password',
            'login.button': 'Accedi',
            'login.loading': 'Accesso in corso...',
            'login.noDashboardAccess': 'Il tuo account non ha accesso alla dashboard.',
            'users.emailLang': 'Lingua email di benvenuto',
            'customers.emailLang': 'Lingua email di benvenuto',
            'register.title': 'Registrazione',
            'register.subtitle': 'Crea il tuo Account',
            'register.email': 'Email',
            'register.confirmPassword': 'Conferma Password',
            'register.button': 'Crea Account',
            'register.loading': 'Creazione account...',
            'sidebar.dashboard': 'Dashboard',
            'sidebar.assets': 'Asset',
            'sidebar.users': 'Utenti',
            'sidebar.settings': 'Impostazioni',
            'sidebar.profile': 'Profilo',
            'customers.title': 'Gestione Clienti',
            'customers.add': 'Nuovo Cliente',
            'customers.edit': 'Modifica Cliente',
            'customers.delete': 'Elimina Cliente',
            'customers.deleteConfirm': 'Sei sicuro di voler eliminare questo cliente?',
            'customers.username': 'Username',
            'customers.email': 'Email',
            'customers.password': 'Password (lascia vuoto per non cambiare)',
            'customers.role': 'Ruolo',
            'customers.priviledge': 'Privilegio (0-100)',
            'customers.notes': 'Note',
            'customers.actions': 'Azioni',
            'customers.save': 'Salva Cliente',
            'customers.cancel': 'Annulla',
            'customers.resend': 'Reinvia Benvenuto',
            'customers.noResults': 'Nessun cliente trovato',
            'customers.search': 'Cerca clienti...',
            'users.title': 'Gestione Utenti',
            'users.subtitle': 'Crea e gestisci gli utenti del sistema',
            'users.newUser': 'Nuovo Utente',
            'users.editUser': 'Modifica Utente',
            'users.resendEmail': 'Reinvia Email',
            'users.role': 'Ruolo',
            'users.priviledge': 'Privilegi',
            'users.username': 'Username',
            'users.email': 'Email',
            'users.password': 'Password (lascia vuoto per non cambiare)',
            'users.actions': 'Azioni',
            'users.save': 'Salva',
            'users.cancel': 'Annulla',
            'users.delete': 'Elimina',
            'users.admin': 'Admin',
            'users.user': 'Utente',
            'users.editor': 'Editor',
            'sidebar.roles': 'Ruoli',
            'sidebar.permissions': 'Permessi',
            'roles.title': 'Gestione Ruoli',
            'roles.subtitle': 'Crea e gestisci i ruoli e i loro permessi',
            'roles.newRole': 'Nuovo Ruolo',
            'roles.editRole': 'Modifica Ruolo',
            'roles.name': 'Nome Ruolo',
            'roles.permissions': 'Permessi Associati',
            'roles.noPermissions': 'Nessun permesso selezionato',
            'permissions.title': 'Gestione Permessi',
            'permissions.subtitle': 'Definisci i permessi bitwise del sistema',
            'permissions.newPermission': 'Nuovo Permesso',
            'permissions.name': 'Nome Permesso',
            'permissions.type': 'Tipo',
            'permissions.target': 'Target (Route/Entità)',
            'permissions.value': 'Valore Bitwise',
            'permissions.route': 'Rotta',
            'permissions.entity': 'Entità',
            'permissions.other': 'Altro',
            'toast.userCreated': 'Utente creato con successo',
            'toast.userUpdated': 'Utente aggiornato con successo',
            'toast.userDeleted': 'Utente eliminato',
            'toast.emailResent': 'Email reinviata con successo',
            'common.deleteUserConfirm': 'Sei sicuro di voler eliminare questo utente?',
            'settings.title': 'Impostazioni Progetto',
            'settings.logo': 'Logo del Progetto',
            'settings.background': 'Immagine di Sfondo',
            'settings.upload': 'Trascina o clicca per caricare',
            'settings.remove': 'Rimuovi',
            'settings.palette': 'Palette Colori',
            'settings.primary': 'Primario',
            'settings.secondary': 'Secondario',
            'settings.accent': 'Accento',
            'settings.labels': 'Etichette Sezioni',
            'settings.staffLabel': 'Etichetta Staff (Utenti)',
            'settings.customerLabel': 'Etichetta Clienti',
            'settings.cancel': 'Annulla',
            'settings.save': 'Salva Modifiche',
            'settings.saving': 'Salvataggio...',
            'profile.title': 'Profilo Utente',
            'profile.passwordTitle': 'Cambio Password',
            'profile.oldPassword': 'Password Attuale',
            'profile.newPassword': 'Nuova Password',
            'profile.updateButton': 'Aggiorna Password',
            'profile.updating': 'Aggiornamento...',
            'profile.language': 'Lingua',
            'assets.title': 'Gestore Asset',
            'assets.subtitle': 'Gestisci i file del tuo progetto',
            'assets.search': 'Cerca file...',
            'assets.upload': 'Carica File',
            'assets.loading': 'Caricamento assets...',
            'assets.empty': 'Nessun file trovato',
            'assets.emptyDetail': 'Inizia caricando qualche asset per il tuo progetto',
            'assets.total': 'asset totali',
            'assets.close': 'Chiudi',
            'toast.loginSuccess': 'Login effettuato con successo',
            'toast.loginError': 'Credenziali non valide',
            'toast.settingsSaved': 'Impostazioni salvate con successo',
            'toast.settingsError': 'Errore durante il salvataggio',
            'toast.assetUploaded': 'file caricati con successo',
            'toast.assetError': 'Errore nel caricamento del file',
            'toast.assetDeleted': 'Asset eliminato',
            'toast.passwordError': 'Errore durante l\'aggiornamento',
            'common.confirm': 'Sei sicuro?',
            'common.deleteConfirm': 'Sei sicuro di voler eliminare questo asset?',
            'common.new': 'Nuovo',
            'common.save': 'Salva',
            'common.required': 'obbligatorio'
        },
        en: {
            'dashboard.title': 'Management Dashboard',
            'dashboard.welcome': 'Welcome Back!',
            'dashboard.welcomeDetail': 'Welcome to your management area.',
            'dashboard.userInfo': 'User Information',
            'dashboard.authStatus': 'Authentication Status',
            'dashboard.features': 'Features',
            'dashboard.logout': 'Logout',
            'login.title': 'Login',
            'login.subtitle': 'Welcome back! Please login',
            'login.email': 'Email',
            'login.username': 'Username',
            'login.password': 'Password',
            'login.button': 'Login',
            'login.loading': 'Logging in...',
            'login.noDashboardAccess': 'Your account does not have dashboard access.',
            'users.emailLang': 'Welcome email language',
            'customers.emailLang': 'Welcome email language',
            'register.title': 'Register',
            'register.subtitle': 'Create your Account',
            'register.email': 'Email',
            'register.confirmPassword': 'Confirm Password',
            'register.button': 'Create Account',
            'register.loading': 'Creating account...',
            'sidebar.dashboard': 'Dashboard',
            'sidebar.assets': 'Assets',
            'sidebar.users': 'Users',
            'sidebar.settings': 'Settings',
            'sidebar.profile': 'Profile',
            'customers.title': 'Customer Management',
            'customers.add': 'New Customer',
            'customers.edit': 'Edit Customer',
            'customers.delete': 'Delete Customer',
            'customers.deleteConfirm': 'Are you sure you want to delete this customer?',
            'customers.username': 'Username',
            'customers.email': 'Email',
            'customers.password': 'Password (leave empty to keep current)',
            'customers.role': 'Role',
            'customers.priviledge': 'Privilege (0-100)',
            'customers.notes': 'Notes',
            'customers.actions': 'Actions',
            'customers.save': 'Save Customer',
            'customers.cancel': 'Cancel',
            'customers.resend': 'Resend Welcome',
            'customers.noResults': 'No customers found',
            'customers.search': 'Search customers...',
            'users.title': 'User Management',
            'users.subtitle': 'Create and manage system users',
            'users.newUser': 'New User',
            'users.editUser': 'Edit User',
            'users.resendEmail': 'Resend Email',
            'users.role': 'Role',
            'users.priviledge': 'Privileges',
            'users.username': 'Username',
            'users.email': 'Email',
            'users.password': 'Password (leave empty to keep current)',
            'users.actions': 'Actions',
            'users.save': 'Save',
            'users.cancel': 'Cancel',
            'users.delete': 'Delete',
            'users.admin': 'Admin',
            'users.user': 'User',
            'users.editor': 'Editor',
            'sidebar.roles': 'Roles',
            'sidebar.permissions': 'Permissions',
            'roles.title': 'Role Management',
            'roles.subtitle': 'Create and manage roles and their permissions',
            'roles.newRole': 'New Role',
            'roles.editRole': 'Edit Role',
            'roles.name': 'Role Name',
            'roles.permissions': 'Associated Permissions',
            'roles.noPermissions': 'No permissions selected',
            'permissions.title': 'Permission Management',
            'permissions.subtitle': 'Define system bitwise permissions',
            'permissions.newPermission': 'New Permission',
            'permissions.name': 'Permission Name',
            'permissions.type': 'Type',
            'permissions.target': 'Target (Route/Entity)',
            'permissions.value': 'Bitwise Value',
            'permissions.route': 'Route',
            'permissions.entity': 'Entity',
            'permissions.other': 'Other',
            'toast.userCreated': 'User created successfully',
            'toast.userUpdated': 'User updated successfully',
            'toast.userDeleted': 'User deleted',
            'toast.emailResent': 'Email resent successfully',
            'common.deleteUserConfirm': 'Are you sure you want to delete this user?',
            'settings.title': 'Project Settings',
            'settings.logo': 'Project Logo',
            'settings.background': 'Background Image',
            'settings.upload': 'Drag or click to upload',
            'settings.remove': 'Remove',
            'settings.palette': 'Color Palette',
            'settings.primary': 'Primary',
            'settings.secondary': 'Secondary',
            'settings.accent': 'Accent',
            'settings.labels': 'Section Labels',
            'settings.staffLabel': 'Staff Label (Users)',
            'settings.customerLabel': 'Customers Label',
            'settings.cancel': 'Cancel',
            'settings.save': 'Save Changes',
            'settings.saving': 'Saving...',
            'profile.title': 'User Profile',
            'profile.passwordTitle': 'Change Password',
            'profile.oldPassword': 'Current Password',
            'profile.newPassword': 'New Password',
            'profile.updateButton': 'Update Password',
            'profile.updating': 'Updating...',
            'profile.language': 'Language',
            'assets.title': 'Asset Manager',
            'assets.subtitle': 'Manage your project files',
            'assets.search': 'Search files...',
            'assets.upload': 'Upload File',
            'assets.loading': 'Loading assets...',
            'assets.empty': 'No files found',
            'assets.emptyDetail': 'Start by uploading some assets for your project',
            'assets.total': 'total assets',
            'assets.close': 'Close',
            'toast.loginSuccess': 'Login successful',
            'toast.loginError': 'Invalid credentials',
            'toast.settingsSaved': 'Settings saved successfully',
            'toast.settingsError': 'Error while saving',
            'toast.assetUploaded': 'files uploaded successfully',
            'toast.assetError': 'Error uploading file',
            'toast.assetDeleted': 'Asset deleted',
            'toast.passwordError': 'Error during update',
            'common.confirm': 'Are you sure?',
            'common.deleteConfirm': 'Are you sure you want to delete this asset?',
            'common.new': 'New',
            'common.save': 'Save',
            'common.required': 'required'
        }
    };

    constructor(@Inject(PLATFORM_ID) private platformId: Object) {
        if (isPlatformBrowser(this.platformId)) {
            const saved = localStorage.getItem('app_lang') as Language;
            if (saved && (saved === 'it' || saved === 'en')) {
                this.currentLang.set(saved);
            }
        }
    }

    setLanguage(lang: Language) {
        this.currentLang.set(lang);
        if (isPlatformBrowser(this.platformId)) {
            localStorage.setItem('app_lang', lang);
        }
    }

    translate(key: string): string {
        return this.translations[this.currentLang()][key] || key;
    }

    // Helper for reactive templates using the signal directly
    t(key: string): string {
        return this.translate(key);
    }
}
